<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> BANNER PEDIDO EXPRESS </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="banner.id">{{ banner.id }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="6">
              <v-row>
                <v-col cols="12" xs="12" md="12">
                  <v-text-field
                    v-model="banner.text"
                    label="Texto Linha 1"
                    dense
                    outlined
                    required
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" md="12">
                  <v-text-field
                    v-model="banner.description"
                    label="Texto Linha 2"
                    dense
                    outlined
                    required
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <!-- <v-col cols="12" xs="12" md="6"> </v-col> -->
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" md="6">
                  <p class="font-weight-bold">Escolher a Cor de Fundo</p>
                  <v-color-picker
                    dot-size="25"
                    swatches-max-height="200"
                    hide-inputs
                    v-model="banner.background_color"
                  ></v-color-picker>
                  <label class="font-weight-bold">{{
                    banner.background_color
                  }}</label>
                </v-col>
                <v-col cols="12" xs="12" md="6">
                  <p class="font-weight-bold">Escolher a Cor do texto</p>
                  <v-color-picker
                    dot-size="25"
                    swatches-max-height="200"
                    hide-inputs
                    v-model="banner.text_color"
                  ></v-color-picker>
                  <label class="font-weight-bold">{{
                    banner.text_color
                  }}</label>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" md="6">
                  <v-text-field
                    v-model="banner.date_start"
                    class="text-field-uppercase"
                    label="Data Inicial"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="6"> </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" md="6">
                  <v-text-field
                    v-model="banner.date_end"
                    class="text-field-uppercase"
                    label="Data Final"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="6"> </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn
                    color="blue darken-3"
                    dark
                    class="mt-5"
                    @click="validate"
                  >
                    <v-icon left>mdi-send</v-icon> Salvar
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="1"></v-col>
            <v-col cols="12" xs="12" md="5">
              <v-row>
                <v-col>
                  <label class="text-h5">Preview</label>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-sheet :color="banner.background_color" height="230">
                    <v-row class="fill-height d-flex">
                      <v-col
                        cols="12"
                        class="text-h5 d-flex justify-center align-self-end"
                        :style="{ color: banner.text_color }"
                      >
                        {{ banner.text || "Texto Linha 1" }}
                      </v-col>
                      <v-col
                        cols="12"
                        class="text-h6 d-flex justify-center align-self-top"
                        :style="{ color: banner.text_color }"
                      >
                        {{ banner.description || "Texto Linha 2" }}
                      </v-col>
                    </v-row>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import * as API from "@/api/requests/BannerExpressRequest";

export default {
  components: {},
  data: () => ({
    loading: false,
    banner: {
      id: "",
      text: "",
      description: "",
      background_color: "#5624D1",
      text_color: "#ffffff",
      date_start: "",
      date_end: "",
    },
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getBanner(this.$route.params.id);
      }
    },
    async getBanner(id) {
      // this.showLoading();
      this.loading = true;
      try {
        let data = await API.getById(id);
        this.banner = data;
      } catch (error) {
        this.banner = {};
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    goToBackList() {
      this.$router.push({ name: "BannerExpressList" });
    },
    validate() {
      if (this.$refs.form.validate()) {
        let data = this.banner;
        console.log(data);
        if (this.banner.id === "") {
          this.post(data);
        } else {
          this.update(this.banner.id, data);
        }
      }
    },
    async post(data) {
      this.loading = true;
      try {
        await API.post(data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async update(id, data) {
      this.loading = true;
      try {
        API.update(id, data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}
</style>
